export default __webpack_public_path__ + "static/media/eb-ultra-pro-1.75d9bba8.png";